<template>
  <div class="container-fluid" style="overflow-y: hidden">
    <div class="row" style="margin-bottom: 5px">
      <div class="col">
      </div>
    </div>

    <div class="row" style="height:100%;">
      <div class="col-12" style="height:100%;">
        <b-table
          class="textMiddle"
          style="height: 100%;"
          small
          hover
          bordered
          show-empty
          responsive
          head-variant="light"
          selectable
          select-mode="single"
          :items="dutsNaviTrack2TCPServer"
          :fields="headers"
          v-bind:emptyText="$store.state.localization.data.common.table.noData"
          @row-clicked="itemClicked"
          v-bind:sticky-header="clientHeight"
        >
          <template #cell(fuelDepo)="data">
            {{ formatFuelDepo(data.item.fuelDepoId) }}
          </template>
          <template #cell(fuelTank)="data">
            {{ formatFuelTank(data.item) }}
          </template>
          <template v-slot:empty="scope">
            <div class="row justify-content-md-center">
              <h5>{{ scope.emptyText }}</h5>
            </div>
          </template>
          <template>
            <span class="text-success"></span>
          </template>
        </b-table>
      </div>
    </div>
  </div>
</template>

<script>

export default {
  name: "ListDutsNaviTrack2TcpServerPage",
  props: {
    users: Array,
    dutsNaviTrack2TCPServer: Array,
    fuelDepos: Array,
    fuelTanks: Array,
  },
  data() {
    return {
      currentSelectedItem: null
    };
  },
  computed: {
    headers() {
      const headers = [];

      for (let key in this.$store.state.localization.data.mainPage.azk.dutsNaviTrack2TCPServer
          .tableColumns) {
            if (
              key == "id" ||
              key == "fuelDepo" ||
              key == "nameDut" ||
              key == "fuelTank" ||
              key == "tcpIpAddress" ||
              key == "tcpPort" ||
              key == "fuelLevelCorrection" ||
              key == "waterLevelCorrection"
            ) {
              headers.push({
                key: key,
                label:
                  this.$store.state.localization.data.mainPage.azk.dutsNaviTrack2TCPServer.tableColumns[
                    key
                  ],
                sortable: true,
                thClass: "textMiddle",
              });
            }
        }

      return headers;
    },
    clientHeight() {
      const FUEL_TANKS_POSITION_Y = 140;

      return `${
        document.documentElement.clientHeight - FUEL_TANKS_POSITION_Y
      }px`;
    },
  },
  methods: {
    itemClicked(row) {
      this.currentSelectedItem = row;
    },
    formatFuelDepo(fuelDepoId) {
      for (let i = 0; i < this.fuelDepos.length; i++) {
        if (
          this.fuelDepos[i].id == fuelDepoId
        ) {
          return this.fuelDepos[i].name;
        }
      }

      return "";
    },
    formatFuelTank(dut) {
      for (let i = 0; i < this.fuelTanks.length; i++) {
        if (
          this.fuelTanks[i].clientId == dut.clientId && this.fuelTanks[i].fuelTankId == dut.fuelTankId
        ) {
          return this.fuelTanks[i].name;
        }
      }

      return "";
    },
  },
};
</script>
